const templateModule = {
  title: 'Modelos',
  new: 'Crear Modelo',
  newAi: 'Modelo Inteligente',
  key: 'Clave',
  words: {
    here: 'aquí',
  },
  alert: {
    text: 'Cree y administre plantillas de documentos que se pueden completar con flujos o integraciones a través de API.',
    action: 'Ver documentación',
  },
  status: {
    created: 'Cargando...',
    published: '@:templateModule.status.created',
    failed: {
      unknown: 'error',
      formatInvalid: 'Formato inválido',

      reason: {
        incorrectImageTag:
          'La etiqueta: "{tag}" en el modelo es incorreta. Asegúrate de que la etiqueta de "imagen" esté en minúsculas. Ejemplo: "[imagen] variable".',
        unopenedTag: 'Variable abierta incorrectamente, faltan llaves al inicio. Ej.: {tag}}}',
        unclosedTag: 'Variable cerrada incorrectamente, faltan llaves al final. Ej.:  {tag}',
        undefined:
          'El formato del archivo puede no estar en .docx o puede haber errores en las variables',
      },
    },
  },
  list: {
    invalidWarning: 'Existen modelos que no son válidos en la lista. Verifica cómo corregir  {0}.',
    pendingTemplatetesWarning:
      'Procesando los últimos modelos. Espera para visualizarlos en esta lista',
    loading: 'Cargando la lista de modelos...',
    empty: 'Crea tu modelo para que Clicksign genere tus documentos de manera automática',
    keyHelp: 'Clave para generación de documentos vía API.',
    actions: {
      generate: 'Generar documento',
      options: 'Opciones',
    },
    emptyFlow: 'Selecciona este modelo en un {0} ó {1} para crear un proceso automatizado.',
    formFlow: 'flujo com formulario',
    spreadsheetFlow: 'flujo con planilla',
    searchField: 'Busca por el nombre del modelo',
    tabs: {
      templates: 'Tus modelos',
      examples: 'Ejemplos',
    },
    examples: {
      alert:
        'Los documentos de Ejemplos sirven como material de consulta para la creación de tus flujos.',
      viewTemplate: 'Ver modelo',
      exampleList: {
        tuitionAgreement: {
          title: 'Contrato de Financiamiento de Servicios Educativos',
          description:
            'Documento contractual que formaliza el compromiso financiero entre el alumno o su responsable y la institución educativa para cubrir los servicios prestados, detallando montos, plazos, formas de pago y condiciones de cancelación.',
        },
        beneficiaryNomination: {
          title: 'Documento de Designación de Beneficiario',
          description:
            'Documento utilizado para formalizar la designación o modificación de los beneficiarios de un contrato de seguro, especificando el porcentaje de participación de cada uno y su parentesco con el asegurado.',
        },
        realEstateRepresentation: {
          title: 'Contrato de Representación Comercial Inmobiliaria',
          description:
            'Contrato de representación comercial enfocado en el sector inmobiliario, especialmente para formalizar la relación entre agentes inmobiliarios independientes e inmobiliarias.',
        },
        portabilityTerm: {
          title: 'Documento de Portabilidad',
          description:
            'Documento que formaliza la solicitud del cliente para transferir su operación de crédito (como préstamos o financiamientos) de una institución financiera a otra, incluyendo datos personales, información sobre la operación a transferir y declaraciones de conocimiento y autorización.',
        },
        serviceAgreement: {
          title: 'Contrato de Prestación de Servicios',
          description:
            'Documento que formaliza la contratación de una parte (prestador) para realizar servicios específicos a favor de otra (contratante), definiendo obligaciones, plazos, formas de pago, responsabilidades y condiciones de cancelación.',
        },
        residentialLease: {
          title: 'Contrato de Arrendamiento de Inmueble Residencial',
          description:
            'Documento que establece los términos del uso de un inmueble residencial por parte del arrendador (propietario) al arrendatario (inquilino), mediante el pago de una renta, detallando cláusulas como monto, plazo, ajustes, garantías, deberes de las partes y condiciones de uso y devolución del inmueble.',
        },
      },
    },
  },
  notification: {
    success: {
      destroy: 'Modelo {name} eliminado con éxito.',
    },
    error: {
      destroy: 'Error al eliminar el  modelo.',
    },
  },
  merge: {
    title: 'Generar documento',
    info: 'Crea un documento y envíalo para firma.',
    fileNameLabel: 'Nombre del documento que será generado',
    fileNameTip:
      "Para que el documento sea creado dentro de una carpeta, simplemente ingresa el nombre de la carpeta en este campo. Por ejemplo, '/carpeta 1/carpeta 2/contrato 123.docx'.",
    templateText: 'Agrega las variables del documento en formato json',
    action: 'Generar',
    errors: {
      generic: 'Ocurrió un error al generar el documento. Por favor, inténtelo de nuevo más tarde.',
    },
  },
  modalPrivacy: {
    title: 'Definir permisos de acceso del modelo',
    selectAccessType: {
      label: 'Selecciona el tipo de acceso del modelo',
      public: 'Acceso para todos los usuarios de la cuenta',
      private: 'Acceso solo para usuarios seleccionados',
    },
    selectGroupsLabel: 'Seleccione los grupos que tendrán acceso al modelo',
    selectMembers: {
      label: 'Selecciona los usuarios que tendrán acceso al modelo',
      admin: 'Administrador',
      adminInfo: 'Por defecto, los administradores de la cuenta tendrán acceso',
    },
    notification: {
      updated: 'Permisos de acceso actualizados con éxito.',
      error: 'No fue posible actualizar los permisos de acceso',
    },
  },
  modalDelete: {
    title: '¿Eliminar modelo?',
    description: '¿Estás seguro de que deseas eliminar este modelo?',
  },
};

export default templateModule;
